import colorProxy from '../../utils/color-proxy';

const black = '#161616';
const dark = '#474747';
const white = '#ffffff';
const whiteClear = '#ffffff4d';
const whiteFaded = '#ffffff5d';
const purple = '#813DFF';
const vividPurple = '#8a55fb';
const brightPurple = '#A270FF';
const primary = purple;
const vividPrimary = vividPurple;
const border = dark;
const borderSecondary = '#ebebeb';
const borderLight = '#d4d4d4';
const lightGrey = '#f8f8f8';
const grey = '#666';
const grey2 = '#dddddd';
const grey3 = '#EBEBEB';
const grey4 = '#D4D4D4';
const grey7 = '#959595';
const silver = '#C4C4C4';
const danger = '#d07c7c';

export const colors = colorProxy({
  bg: white,
  content: black,
  black,
  white,
  whiteClear,
  whiteFaded,
  dark,
  primary,
  purple,
  vividPurple,
  brightPurple,
  vividPrimary,
  lightGrey,
  grey,
  grey2,
  grey3,
  grey4,
  grey7,
  silver,
  danger,
  border,
  borderSecondary,
  borderLight
});
